// import React, { useCallback, useState } from 'react';

// import { BorrowerLeadGenerationTool } from 'borrower-lead-generation-tool';

// const Contact = (props) => {
//   // stores current formRef
//   const [node, setNode] = useState(null);
//   // tracks changes to formRef and stores current with setNode
//   const formRef = useCallback((node) => {
//     setNode(node);
//   }, []);

//   return (
//     <>
//       <div className="formWrapper">
//         {node && (
//           <div
//             className="formHeader"
//             style={{ padding: '.75rem 1rem 0 1rem', textAlign: 'center' }}>
//               {props.header ? props.header : "Por favor complete la siguiente información para continuar"}
//             Contact Us
//           </div>
//         )}
//         <div className="formBody">
//           <BorrowerLeadGenerationTool ref={formRef} leadSource="swmc.com" />
//         </div>
//       </div>
//     </>
//   );
// };

// export default Contact;



import React, { useCallback, useState} from "react";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
// import styles from './index.module.css';

const Contact = (props) => {
  // stores current formRef
  const [node, setNode] = useState("");
  // tracks changes to formRef and stores current with setNode
  const formRef = useCallback((node) => {
    setNode(node);
  }, []);

 
  return (
    <div className="formWrapper" id="generateLead">
      {/* {node && (
        // dynamically renders the custom form header
        <div className="formHeader">
          {props.header ? props.header : "Por favor complete la siguiente información para continuar"}
        </div>
      )} */}
      <div className="formBody">
        <BorrowerLeadGenerationTool
          ref={formRef} leadSource="swmc.com"
          loanOfficerUid="CSTC"
          statesDomain={process.env.REACT_APP_STATE_DOMAIN}
        />
      </div>
    </div>
  );
};

export default Contact;
